import { useTranslation } from 'next-i18next';
import React from 'react';
import getCurrentYear from '../../utils/timeUtils';
import formatSiteName from '../../utils/formatSiteName';
import SiteMapping from '../../configs/siteMapping';

const FootText = ({ siteName }) => {
    const { t } = useTranslation();
    let text;

    switch (siteName) {
    case SiteMapping.taraPlays:
        text = t('lbl_RecmndRsltn');
        break;
    default:
        text = `© Copyright ${getCurrentYear()}. ${formatSiteName(siteName)}. All Rights Reserved.`;
        break;
    }

    return <>{text}</>;
};

export default FootText;
